import Button from '@atoms/Button/Button';
import CheckboxInput from '@atoms/Inputs/CheckboxInput';
import options from '@config/matchmaker/shiftTypes';
import {
  AFTERNOON_SHIFT_KEY,
  CATERING_INDUSTRY_FUNCTION_CATEGORY_CODE,
  EVENING_SHIFT_KEY,
  FACILITY_FUNCTION_CATEGORY_CODE,
  HEALTHCARE_FUNCTION_CATEGORY_CODE,
  HOLIDAY_WORKER_APPLICATION_CODE,
  LONG_SHIFT_KEY,
  MORNING_SHIFT_KEY,
  SHORT_SHIFT_KEY,
  TREATMENT_FUNCTION_CATEGORY_CODE,
  VOLUNTEER_APPLICATION_CODE,
  WEEKEND_SHIFT_KEY,
  WELL_BEING_FUNCTION_CATEGORY_CODE,
} from '@constants';
import { vacancyFiltersType } from '@lib/proptypes';
import MatchMakerQuestion from '@molecules/MatchMaker/MatchMakerQuestion';
import { useMatchmakerQuestion } from '@utils';
import useApplicationFormsAnswer from '@utils/matchmaker/useApplicationFormsAnswer';
import useFunctionCategoriesAnswer from '@utils/matchmaker/useFunctionCategoriesAnswer';
import PropTypes from 'prop-types';

import styles from './Matchmaker.module.scss';

const filterKey = 'shiftTypes';

export default function Question6({ filters, handleNavigation }) {
  const { selectedApplicationFormCode } = useApplicationFormsAnswer(filters);
  const { selectedFunctionCategoryCode } = useFunctionCategoriesAnswer();

  const shiftTypes = options.filter(shift => {
    if (
      selectedFunctionCategoryCode === WELL_BEING_FUNCTION_CATEGORY_CODE ||
      selectedFunctionCategoryCode === HEALTHCARE_FUNCTION_CATEGORY_CODE
    ) {
      return true;
    }

    if (
      selectedFunctionCategoryCode === TREATMENT_FUNCTION_CATEGORY_CODE &&
      ![
        MORNING_SHIFT_KEY,
        AFTERNOON_SHIFT_KEY,
        EVENING_SHIFT_KEY,
        SHORT_SHIFT_KEY,
        LONG_SHIFT_KEY,
      ].includes(shift.key)
    ) {
      return false;
    }

    if (
      [
        FACILITY_FUNCTION_CATEGORY_CODE,
        CATERING_INDUSTRY_FUNCTION_CATEGORY_CODE,
      ].includes(selectedFunctionCategoryCode) &&
      ![
        MORNING_SHIFT_KEY,
        AFTERNOON_SHIFT_KEY,
        EVENING_SHIFT_KEY,
        WEEKEND_SHIFT_KEY,
        SHORT_SHIFT_KEY,
        LONG_SHIFT_KEY,
      ].includes(shift.key)
    ) {
      return false;
    }

    if (
      selectedApplicationFormCode === VOLUNTEER_APPLICATION_CODE &&
      ![
        MORNING_SHIFT_KEY,
        AFTERNOON_SHIFT_KEY,
        EVENING_SHIFT_KEY,
        WEEKEND_SHIFT_KEY,
      ].includes(shift.key)
    ) {
      return false;
    }

    if (
      selectedApplicationFormCode === HOLIDAY_WORKER_APPLICATION_CODE &&
      ![
        MORNING_SHIFT_KEY,
        AFTERNOON_SHIFT_KEY,
        EVENING_SHIFT_KEY,
        WEEKEND_SHIFT_KEY,
        SHORT_SHIFT_KEY,
        LONG_SHIFT_KEY,
      ].includes(shift.key)
    ) {
      return false;
    }

    return true;
  });

  const {
    inputs,
    handleChange,
    hasSelectedAll,
    toggleAll,
    handlePreviousUrl,
    handleNextUrl,
  } = useMatchmakerQuestion({
    key: filterKey,
    callback: handleNavigation,
    filters: { shiftTypes },
    initialState: state =>
      shiftTypes.filter(option => +state[option.key]).map(option => option.key),
    saveStateAs: () =>
      options.reduce(
        (parameters, option) => ({
          ...parameters,
          [option.key]: inputs.shiftTypes.includes(option.key) ? '1' : '0',
        }),
        {}
      ),
  });

  return (
    <MatchMakerQuestion
      number={6}
      total={7}
      question="Wat voor een soort diensten wil je werken?"
      extraClasses={styles.matchMakerQuestion}
    >
      <div className={styles.inputsContainer}>
        {shiftTypes.map(({ title, key }) => (
          <CheckboxInput
            key={`shift-type-${key}`}
            id={key}
            value={key}
            name={filterKey}
            onChange={handleChange}
            label={title}
            checked={inputs[filterKey].includes(key)}
            groupCheckbox
          />
        ))}

        <CheckboxInput
          id="shift-type-all"
          value=""
          name={filterKey}
          onChange={toggleAll}
          label="Maakt me niet uit"
          checked={hasSelectedAll}
          groupCheckbox
        />
      </div>

      <p className={styles.choiceHelp}>Je mag meerdere opties aanvinken</p>

      <div className={styles.ctaContainer}>
        <Button
          key="matchmaker-back-button"
          label="Terug"
          href="/matchmaker/5"
          size="smallMobile"
          onClick={handlePreviousUrl}
          color="secondary"
        />
        <Button
          key="matchmaker-next-button"
          label="Volgende"
          href="/matchmaker/7"
          size="smallMobile"
          onClick={handleNextUrl}
          disabled={!inputs.shiftTypes.length}
        />
      </div>
    </MatchMakerQuestion>
  );
}

Question6.propTypes = {
  filters: vacancyFiltersType,
  handleNavigation: PropTypes.func,
};
